'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  function accept() {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  }

  function dismiss() {
    localStorage.setItem('cookie-consent', 'dismissed');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="max-w-4xl mx-auto bg-gray-900 text-gray-100 rounded-xl shadow-2xl px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm flex-1">
          We use essential cookies to keep you signed in and make the site work. We don&apos;t use tracking or advertising cookies.{' '}
          <Link href="/cookies" className="text-blue-400 hover:text-blue-300 underline">
            Learn more
          </Link>
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={dismiss}
            className="text-sm text-gray-400 hover:text-gray-200 transition-colors px-3 py-2"
          >
            Dismiss
          </button>
          <button
            onClick={accept}
            className="text-sm bg-blue-600 hover:bg-blue-700 text-white font-semibold px-5 py-2 rounded-lg transition-colors"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
